<template>
  <main>
    <section-hero :bgImg="bgImg" :subtitle="subtitle"></section-hero>
    <section class="section--contact" id="scrollToOnLoad">
      <b-container>
        <b-row>
          <b-col sm="6" class="contact order-2 order-sm-1">
            <h2>{{ $t("contactUs.title") }}
              <span class="text--shadow-right">{{ $t("contactUs.title") }}</span>
            </h2>
            <p class="contact__information">{{ $t("contactUs.header") }}</p>
            <span class="contact__address contact__address--ico">ETH Zurich</span>
            <span class="contact__address">Lab. für Organische Chemie</span>
            <span class="contact__address">Prof. Dr. Jeffrey W. Bode</span>
            <span class="contact__address">HCI F 315</span>
            <span class="contact__address">Vladimir-Prelog-Weg 1-5/10</span>
            <span class="contact__address">8093 Zürich</span>
            <span class="contact__address">Switzerland</span>
            <a class="contact__phone" href="tel:+41758469785">+41 44 633 21 03</a>
            <a class="contact__email" href="mailito:hello@makeamolecule.com">
              hello@makeamolecule.com
            </a>
          </b-col>
          <b-col sm="6" xl="5" offset-xl="1" class="order-1 order-sm-2">
            <div
              v-if="scientists.length"
              class="d-flex justify-content-center justify-content-sm-between flex-wrap">
              <div class="scientist mb-2" v-for="(scientist, index) in scientists" :key="index">
                <img class="scientist__img  img-fluid" :src="domain + scientist.photo.url">
                <div
                class="scientist__content d-flex flex-column justify-content-between text-center">
                  <div class="mt-4">
                    <span class="scientist__name">
                      {{ scientist.first_name }} {{ scientist.last_name }}
                    </span>
                    <p class="text--small text--white">
                      {{ scientist.position }}, {{ scientist.school }}
                    </p>
                  </div>
                  <ul class="scientist__social-media mb-3">
                    <li><a :href="scientist.linkedin_url" target="_blank">
                      <i class="fab fa-linkedin"></i></a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <section class="section--write-us">
      <b-container>
        <b-row>
          <b-col cols="6" sm="4" lg="5" xl="4" offset="3" offset-sm="0" offset-xl="1">
              <img class="user__img" src="@/assets/ico-person-gray.svg" alt="">
          </b-col>
          <b-col lg="7" sm="8" class="mt-4 mt-sm-0">
              <h1 class="text--black">{{ $t("contactUs.WriteToUs") }}</h1>
              <span class="user__text">{{ $t("contactUs.agora") }}</span>
            <b-form @submit.prevent="askQuestion">
              <b-form-input
                type="text" v-model="user.name" required :placeholder="$t('FullName')" class="mb-3">
              </b-form-input>
              <b-form-input
                  type="email"
                  v-model="user.email"
                  required placeholder="E-mail" class="mb-3">
              </b-form-input>
              <b-form-textarea
                class="form__message mb-3"
                v-model="user.body"
                required :placeholder="$t('message')"
                :rows="3">
              </b-form-textarea>
              <b-col class="text-center text-sm-right mt-3 mt-sm-0">
                <span v-if="success" class="log__succes">
                  {{ $t("contactUs.alert") }}
                </span>
                <b-btn variant="primary" size="sm" type="submit">{{ $t("send") }}</b-btn>
              </b-col>
            </b-form>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <section-map></section-map>
  </main>
</template>

<script>
import scientist from '@/api/v1/askScientis';
import support from '@/api/v1/support';
import Hero from '@/components/Hero';
import GoogleMap from '@/views/ContactUs/GoogleMap';

export default {
  data() {
    return {
      bgImg: 'Banner6-Contact-us-',
      subtitle: this.$t('nav.contactUs'),
      success: false,
      scientists: [],
      domain: process.env.SERVER_URL,
      user: {
        name: '',
        email: '',
        body: '',
      },
    };
  },
  components: {
    'section-hero': Hero,
    'section-map': GoogleMap,
  },
  methods: {
    askQuestion() {
      const succ = () => {
        this.user = '';
        this.success = true;
      };
      support.send(this.user, succ);
    },
    getScientist() {
      const succ = (response) => {
        this.scientists = response.data.our_scientists.scientists;
      };
      scientist.index(succ);
    },
  },
  created() {
    this.getScientist();
  },
};
</script>

<style lang="scss" scoped>
@import './src/styles/helpers/_variables.scss';
@import './src/styles/helpers/_include-media.scss';
@import './src/styles/helpers/contact_us_style.scss';

.section {
  &--contact {
  padding: 100px 0;
  @include media('<lg') {
    padding: 50px 0;
  }
}
  &--write-us {
    background-color: $color--gray-4;
    padding: 100px 0 75px;
    @include media('<md') {
      padding: 40px 0;
    }
  }
}
.form__message {
  max-height: 200px;
  min-height: 75px;
}
.scientist {
  position: relative;
  width: 225px;
  height: 190px;
  @include media('<xl') {
    width: 180px;
    height: 165px;
  }
   @include media('<lg') {
      width: 118px;
      height: 99px;
    }
  &:hover {
    .scientist__content {
    opacity: 1;
    }
  }
  &__text {
    font-size: 16px;
    padding-top: 40px;
    line-height: 20px;
    @include media('<md') {
      padding-top: 15px;
    }
  }
  &__questions {
    font-size: 16px;
    font-style: italic;
    padding-top: 40px;
    max-width: 260px;
    margin: 0 auto;
  }
  &__name {
    font-size: 20px;
    font-weight: 800;
  }
  &__content {
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    background-color: $color--orange;
    width: 100%;
    height: 100%;
    transition: opacity 0.5s ease;
  }
  &__social-media {
    display: flex;
    justify-content: space-between;
    padding: 0 30px;
    svg {
      height: 25px;
      width: auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/ContactUs/Index.vue